import { OrganizationCode } from 'merchandising-sdk';

export const environment = {
  production: false,
  organization: OrganizationCode.CI,
  is_online: true,
  assets_url: 'https://stmerchandisingci.blob.core.windows.net/ci-assets',
  storage_token: 'sv=2025-07-05&spr=https&st=2026-08-18T14%3A53%3A13Z&se=2035-12-31T15%3A53%3A00Z&sr=c&sp=racwdxltf&sig=vGJ1JIJO%2FQczIC5GqbMw7CXApSQpaMSClj5ZCUqogK0%3D',
  local_db_name: 'merchandising.db',
  azure_blob_sas_url: ``,
  azure_container: `ci-assets`
};